export const YOUTUBE_SUBSCRIPTIONS_URL =
  'https://www.googleapis.com/youtube/v3/subscriptions';

export const YOUTUBE_SUBSCRIPTIONS_CHUNK_SIZE = 50;
